export default class ExportConfigModel {
  fields = []
  encoding = ''
  separatorBetween = ''
  separatorWithin = ''
  category_output = ''
  export_type = ''
}
